import { ContentServiceV1Impl } from "./v1";
export * from "./content-store";
export * from "./v1/types";
const optionalFeatureServices = {
    "s2:serialized-state-manager": "^1.0.0",
};
function createLazyStateGetter(initialViewportConsumers, stateManager) {
    let state = initialViewportConsumers;
    return () => {
        if (state) {
            return state;
        }
        if (stateManager) {
            const maybeState = JSON.parse(stateManager.getSerializedState() || "[]");
            if (Array.isArray(maybeState) && maybeState.length) {
                state = maybeState;
            }
        }
        return state;
    };
}
export function defineContentService(store, options = {}) {
    return {
        id: "audi-content-service",
        optionalDependencies: {
            featureServices: optionalFeatureServices,
        },
        create: ({ featureServices }) => {
            const stateManager = featureServices["s2:serialized-state-manager"];
            const { initialViewportConsumers } = options;
            if (stateManager && initialViewportConsumers) {
                stateManager.register(() => JSON.stringify(initialViewportConsumers));
            }
            const lazyInitialViewportConsumer = createLazyStateGetter(initialViewportConsumers, stateManager);
            return {
                "1.1.0": (consumerId) => ({
                    featureService: new ContentServiceV1Impl(consumerId, store, lazyInitialViewportConsumer()?.includes(consumerId) ?? false),
                }),
            };
        },
    };
}
//# sourceMappingURL=index.js.map